

import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import settings from './settings.js'
import Scrollactive from 'vue-scrollactive';
import Affix from 'vue-affix';
import resource  from 'vue-resource';
import VTooltip from 'v-tooltip'
import VueScrollTo from 'vue-scrollto'
import responsive from 'vue-responsive'

Vue.config.productionTip = false

Vue.use(VueScrollTo)
Vue.use(resource);
Vue.use(VTooltip)
Vue.use(Affix);
Vue.use(Scrollactive);
Vue.use(responsive) 

settings.setDefaults();

var app = new Vue({
  el : '#app',
  i18n,
  render: h => h(App)
});

// SUBTLE PARALLAX EFFECT
window.onscroll = function() {
    let l = document.documentElement.scrollTop;
    document.body.style.backgroundPositionY = parseInt(l*.2)+"px" 
};


/*
window.onfocus = function() {
	  console.log('Got focus');
	}

window.onblur = function() {
	  console.log('lost focus');
	}
	*/